import _ from "lodash";
import { tableEnums } from "../../widgets/table/tableFeatures/tableEnums";
import { deepGet } from "../dataFunctions/dataFunctions";

let moment = require('moment');
const {
    startOfWeek,
    endOfWeek,
    startOfYesterday,
    startOfMonth,
    endOfMonth,
    subMonths,
    startOfYear,
    endOfYear,
    subYears
} = require('date-fns');


// функция для разделения разрядов числа
export function thousandSeparator(str: string) {
    let parts = (str + '').split('.'),
        main = parts[0],
        len = main.length,
        output = '',
        i = len - 1;

    while (i >= 0) {
        output = main.charAt(i) + output;
        if ((len - i) % 3 === 0 && i > 0) {
            output = ' ' + output;
        }
        --i;
    }

    if (parts.length > 1) {
        output += ',' + parts[1];
    }
    return output;
}

export function toNumberLikeString(str: any) {
    if (typeof str === 'string') {
        return str?.replace(',', '.')?.replace(/ /, '')
    }
}

// функция для капитализации первой буквы строки
export function capitalize(s: string) {
    return s && s[0].toUpperCase() + s.slice(1)
}

// Функция вычисления самой длинной строки из массива строк
export function getLongestString(arr: any[]) {
    return (
        arr.reduce((savedText: string | any[], text: string | any[]) => (text.length > savedText.length ? text : savedText), '')
    )
}

// функция для подсчета процента
export function calculatePercent(totalNumber: number, partialNumber: number) {
    if (totalNumber > 0) {
        return partialNumber / (totalNumber / 100)
    } else {
        return 0
    }
}

export function convertDate(str: any) {
    var date = new Date(str),
        month = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return str ? [date.getFullYear(), month, day].join("-") : null
}

export function formatDate(item: any) {
    if (item) {
        let newItem
        if (moment(item, "YYYY-MM-DD", true).isValid()) {
            newItem = moment(item).format('DD-MM-YYYY')?.replace(/-/g, '.')
        }
        if (moment(item, "YYYY-MM-DDTHH:mm", true).isValid()) {
            newItem = moment(item).format('DD-MM-YYYY HH:MM')?.replace(/-/g, '.')
        }
        if (moment(item, "YYYY-MM-DDTHH:mm:ssZ", true).isValid()) {
            newItem = moment(item).format('DD-MM-YYYY HH:MM')?.replace(/-/g, '.')
        }
        return newItem
    }
    else return null
}

export function checkToday(dates: any) {
    let today = convertDate(new Date())
    return dates ? convertDate(dates[0]) == today && convertDate(dates[1]) == today : false
}

export function checkYesterday(dates: any) {
    let yesterday = convertDate(startOfYesterday());
    return dates ? convertDate(dates[0]) == yesterday && convertDate(dates[1]) == yesterday : false
}

export function checkThisWeek(dates: any) {
    const today = new Date();
    const currentWeekMonday = startOfWeek(today, {
        weekStartsOn: 1
    }); // Monday as the start of the week
    const currentWeekSunday = endOfWeek(today, {
        weekStartsOn: 1
    });
    return dates ? convertDate(dates[0]) == convertDate(currentWeekMonday) && convertDate(dates[1]) == convertDate(currentWeekSunday) : false
}

export function checkLastWeek(dates: any) {
    const date = new Date()
    date.setDate(date.getDate() - 7)
    const lastWeekMonday = startOfWeek(date, {
        weekStartsOn: 1
    }); // Monday as the start of the week
    const lastWeekSunday = endOfWeek(date, {
        weekStartsOn: 1
    });
    return dates ? convertDate(dates[0]) == convertDate(lastWeekMonday) && convertDate(dates[1]) == convertDate(lastWeekSunday) : false
}

export function checkThisMonth(dates: any) {
    let today = new Date()
    const currentMonthStart = startOfMonth(today)
    const currentMonthEnd = endOfMonth(today)
    return dates ? convertDate(dates[0]) == convertDate(currentMonthStart) && convertDate(dates[1]) == convertDate(currentMonthEnd) : false
}

export function checkLastMonth(dates: any) {
    const date = subMonths(new Date, 1)
    const lastMonthStart = startOfMonth(date)
    const lastMonthEnd = endOfMonth(date)
    return dates ? convertDate(dates[0]) == convertDate(lastMonthStart) && convertDate(dates[1]) == convertDate(lastMonthEnd) : false
}

export function checkThisYear(dates: any) {
    let today = new Date()
    const currentYearStart = startOfYear(today)
    const currentYearEnd = endOfYear(today)
    return dates ? convertDate(dates[0]) == convertDate(currentYearStart) && convertDate(dates[1]) == convertDate(currentYearEnd) : false
}

export function checkLastYear(dates: any) {
    const date = subYears(new Date, 1)
    const lastYearStart = startOfYear(date)
    const lastYearEnd = endOfYear(date)
    return dates ? convertDate(dates[0]) == convertDate(lastYearStart) && convertDate(dates[1]) == convertDate(lastYearEnd) : false
}

// проверка на нахождение числа в строке 
export function formatNumbersInString(str: string): string {
    const regexp = /\d+\.\d{3,}/g;
    const matches = str.match(regexp);

    if (!matches) return str;

    for (const match of matches) {
        const replaced = match.replace('.', ',');
        str = str.replace(match, replaced);
    }

    return str;
}




// функция для форматирования данных таблицы (запятые в числах, даты)
export function prepareTableData(tableValue: any, columns: any, devExtreme?: boolean) {
    // определение списка текущих полей колонок таблицы
    let columnsFields: any = []
    columns.map((col: any) => {
        if (devExtreme) {
            columnsFields.push(col.dataField)
        } else {
            columnsFields.push({
                fieldName: col.field,
                type: col.valueType,
                shouldBeFormatted: col.shouldBeFormatted
            })
        }
    })
    let newValue: any = []
    tableValue && tableValue.map((item: any) => {
        let newItem: any = { ...item }
        // обход по всем полям объекта
        columnsFields.map((columnField: any) => {
            const { fieldName, type, shouldBeFormatted } = columnField
            let currentValue = newItem[fieldName]
            if (fieldName?.includes('.')) {
                currentValue = deepGet(newItem, fieldName.split('.'))
            }
            let newValue = currentValue
            // проверяем на наличие значения, иначе значение остается таким же (отсутствующим)
            if (currentValue != null) {
                if (!shouldBeFormatted) {
                    newItem[fieldName] = newValue
                } else {
                    if (typeof currentValue == 'string') {
                        newValue = formatNumbersInString(currentValue)
                        if (type == "date") {
                            newValue = moment(currentValue).format("DD.MM.YYYY")
                        }
                        if (moment(currentValue, "YYYY-MM-DD", true).isValid()) {
                            newValue = currentValue.split('-').reverse().join('.')
                        }
                        if (moment(currentValue, "YYYY-MM-DDTHH:mm", true).isValid()) {
                            newValue = currentValue.split('T')[0].split('-').reverse().join('.') + ' ' + currentValue.split('T')[1]
                        }
                        if (moment(currentValue, moment.ISO_8601, true).isValid()) {
                            newValue = moment(currentValue).format('DD-MM-YYYY HH:MM').replace(/-/g, '.');
                        }
                        if ((fieldName === 'MaintenancePosition' || fieldName === 'MaintenanceEnding') && currentValue.includes(';')) {
                            newValue = currentValue.split(';')[0]
                        }
                        if (fieldName === 'DefectClassificator') {
                            newValue = currentValue
                        }
                    } else if (typeof currentValue == 'number') {
                        // проверяем, если ли десятичная часть у числа, чтобы не добавлять лишних нулей после запятой
                        if (currentValue?.toString().indexOf(".") !== -1) {
                            newValue = thousandSeparator(currentValue.toFixed(3)?.toString()?.replace('-0.000', '0.000'))
                        } else {
                            newValue = thousandSeparator(currentValue?.toString())
                        }
                        if (fieldName.match(/Forward\dValue/) || fieldName.match(/Reverse\dValue/)) {
                            newValue = thousandSeparator(currentValue.toFixed(1)?.toString())
                        }
                        if (fieldName === "Position" || fieldName === 'Ending' || fieldName === 'startPosition' || fieldName === 'endPosition') {
                            newValue = thousandSeparator(currentValue.toFixed(3)?.toString()?.replace('-0.000', '0.000'))
                        }
                        if (fieldName === 'EventYear' || fieldName === 'Year' || fieldName === 'year') {
                            newValue = currentValue?.toString()
                        }
                        if (fieldName === 'Rating') {
                            newValue = currentValue.toFixed(1)
                        }
                    } else if (typeof currentValue == 'boolean') {
                        // проверяем, если ли десятичная часть у числа, чтобы не добавлять лишних нулей после запятой
                        if (fieldName === 'LessIsBetter') {
                            newValue = currentValue
                        }
                    }
                    if (fieldName?.includes('.')) {
                        _.set(newItem, fieldName, newValue)
                    } else {
                        newItem[fieldName] = newValue
                    }
                }
            }
        })
        // заполняем новый массив данных
        newValue.push(newItem)
    })
    return newValue
}

// функция для форматирования данных объекта (запятые в числах, даты)
export function prepareObjectDataForFavourites(value: any) {
    let newItem: any = {}
    // обход по всем полям объекта
    Object.keys(value).map((key: any) => {
        // производимо форматирование, если текущее поле находится в списке текущих полей колонок таблицы
        let newFieldValue: any = []
        if (key === 'PathEnding' || key === 'PathPosition' || key === 'PlacementString') {
            // проверяем на наличие значения, иначе значение остается таким же (отсутствующим)
            if (value[key] != null) {
                if (typeof value[key] == 'string') {
                    newFieldValue = formatNumbersInString(value[key])
                } else if (typeof value[key] == 'number') {
                    newFieldValue = thousandSeparator(value[key].toFixed(3)?.toString())
                }
                newItem[key] = newFieldValue
            }
        } else {
            newItem[key] = value[key]
        }
    })
    return newItem
}


export function formatDateForFilter(date: any) {
    date = date?.replace(/\./g, '-')
    let newDate: any
    if (date.includes(':')) {
        newDate = date.split(' ')[0].split('-').reverse().join('-') + 'T' + date.split(' ')[1]
    } else {
        newDate = date.split('-').reverse().join('-')
    }
    return newDate
}

export function transformResponse(response: any) {
    let responseCopy: any = { value: [] }
    response && response.value.map((item: any) => {
        let itemCopy: any = {}
        Object.assign(itemCopy, item)
        Object.keys(tableEnums).map((key, index) => {
            if (itemCopy.hasOwnProperty(key) && itemCopy[key] !== null) {
                if (itemCopy[key] === false) {
                    itemCopy[key] = 0
                } else if (itemCopy[key] === true) {
                    itemCopy[key] = 1
                }
                itemCopy[key] = tableEnums[key][itemCopy[key]]
            }
        })
        responseCopy?.value.push(itemCopy)
    })
    return responseCopy
}


export function getValueWithMapLinks(value: any[], objectType: any) {
    return value && value.map((item: any) => ({ ...item, MapLink: `/app/map/${objectType}/${item.InfoObjectID}` }))
}

export function getValueWithObjectCardLinks(value: any[], objectType: any) {
    return value && value.map((item: any) => ({ ...item, ObjectCardLink: `/app/table/${objectType}/${item.InfoObjectID}` }))
}

export function transformArrayWithEnums(value: any) {
    value && value.map((item: any) => {
        Object.keys(tableEnums).map((key, index) => {
            if (item.hasOwnProperty(key) && item[key] !== null) {
                if (item[key] === false) {
                    item[key] = 0
                } else if (item[key] === true) {
                    item[key] = 1
                }
                item[key] = tableEnums[key][item[key]]
            }
        })
    })
    return value
}

export function transformObjectWithEnums(object: any) {
    Object.keys(tableEnums).map((key, index) => {
        if (object.hasOwnProperty(key) && object[key] !== null) {
            if (object[key] === false) {
                object[key] = 0
            } else if (object[key] === true) {
                object[key] = 1
            }
            object[key] = tableEnums[key][object[key]]
        }
    })
    return object
}

// функция для преобразования полученной строки геометрии объекта
export function removeEverySecondChar(inputString: string) {
    let result = '';
    for (let i = 0; i < inputString.length; i++) {
        if (i % 2 === 0) {
            result += inputString[i];
        }
    }
    return result;
}

// шаблон фильтра для получения уникальных значений в массиве
export function uniqueValues(value: any, index: any, array: string | any[]) {
    return array.indexOf(value) === index;
}

export const buildApiUrlQueryParams = (params: Record<string, any>) => {
    const queryParamsString = Object.entries(params)
        .filter(([, value]) => value != null)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    return queryParamsString ? `?${queryParamsString}` : ''
};